
export interface ModalExecutor {
    show: (item: HTMLElement) => void;
    hide: (item: HTMLElement) => void;
}

let modalLauncher: ModalExecutor = {
    show: (modalElement: HTMLElement) => {
        //Modal.getOrCreateInstance(modalElement).show();
    },
    hide: (modalElement: HTMLElement) => {
        //Modal.getOrCreateInstance(modalElement).hide();
    }
};
export function setModalLauncher(launcher: ModalExecutor) {
    modalLauncher = launcher;
}

export function getModalLauncher(): ModalExecutor {
    return modalLauncher;
}